import MuiSelect, { SelectProps } from '@material-ui/core/Select'
import { FormControl, FormHelperText, makeStyles, MenuItem } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import { Colors, FormLabel } from '../controls/helpers';

type Props = SelectProps & { classes?: Record<string, string>, helperText?: string, noBlankOption?: boolean, options: Record<string, string> | string[], hideExpandIcon?: boolean };

const Select = ({ error, label, helperText, classes, options, className, disabled, placeholder, noBlankOption, hideExpandIcon, autoWidth, ...rest }: Props) => {
    const componentClasses = useStyles({ hideExpandIcon });
    const selectRootClass = clsx(componentClasses.root, className);
    const selectOptions = Array.isArray(options) ? options.reduce((acc, o) => ({...acc, [o]: o}), {}) : options;
 
    return <>
        <FormLabel label={label} />
        <FormControl variant="outlined" fullWidth error={error} className={classes?.root}>
            <MuiSelect
                fullWidth
                className={selectRootClass}
                classes={{ select: componentClasses.select }}
                {...rest}
                displayEmpty={false}
                placeholder={placeholder}
                disabled={disabled}
                IconComponent={hideExpandIcon ? undefined : props => <ExpandMoreIcon {...props} style={{ color: disabled ? Colors.DarkGrey : Colors.Black, marginRight: 5 }} />}>
                {(noBlankOption === undefined || noBlankOption === false) && <MenuItem key={0} value="" ></MenuItem>}
                {Object.entries(selectOptions).map(([value, label]) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
            </MuiSelect>
        </FormControl>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </>
}

const useStyles = makeStyles({
    root: ({ hideExpandIcon }: { hideExpandIcon?: boolean }) => ({
        backgroundColor: Colors.White,
        '& svg.MuiSelect-icon': {
            display: hideExpandIcon ? 'none !important' : 'inline-block'
        }
    }),
    select: {
        padding: '16px 41px 16px 16px !important',
        '&:focus': {
            backgroundColor: Colors.White,
            borderRadius: '0.75rem'
        }
    }
}, { name: 'ClientSelect' });
 
export default Select;
 